"use client";

import { SiteTemplatePageSectionTypeSupportDefaultListItemSettingModel } from "@/Apis/ClinicApi";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { SupportSectionProps } from "@/Templates/SectionsProps";
import { FC, ReactElement } from "react";
import HomeEightSupportSectionGenerated, {
  HomeEightSupportSectionGeneratedProps,
} from "../Sections/_generated/HomeEightSupportSection.generated";
import HomeFifteenSupportSectionGenerated, {
  HomeFifteenSupportSectionGeneratedProps,
} from "../Sections/_generated/HomeFifteenSupportSection.generated";
import {
  buildGeneratedSectionProps,
  renderGeneratedSection,
} from "./generated-section-renderer";

type GeneratedSupportRenderer = (props: SupportSectionProps) => ReactElement;

const SupportAppearance =
  CenterOptions.SiteTemplate.SiteTemplateSettings.SiteTemplateSupportAppearance;

function getListItems(
  props: SupportSectionProps,
): SiteTemplatePageSectionTypeSupportDefaultListItemSettingModel[] {
  return props.lists.Default ?? [];
}

function getSectionImageUrl(props: SupportSectionProps): string | undefined {
  return props.setting.Image?.Url ?? undefined;
}

function getSectionImageAlt(
  props: SupportSectionProps,
  fallback: string,
): string {
  return props.setting.Image?.AltText ?? fallback;
}

function getItemText(
  item?: SiteTemplatePageSectionTypeSupportDefaultListItemSettingModel | null,
): string | undefined {
  return item?.Title ?? item?.LinkText ?? undefined;
}

const generatedSupportRenderers: Record<string, GeneratedSupportRenderer> = {
  [SupportAppearance.Home8.key]: (props) => (
    <HomeEightSupportSectionGenerated
      {...buildGeneratedSectionProps<HomeEightSupportSectionGeneratedProps>(
        "HomeEightSupportSection",
        {
          supportSection46s: getListItems(props).map((item, index) => ({
            key: item.Id,
            className:
              [
                "isax isax-profile-tick5",
                "isax isax-ticket-star5",
                "isax isax-calendar-15",
              ][index] ?? "isax isax-profile-tick5",
            h30Text: item.Title ?? "",
            link0Text: item.LinkText ?? "",
            href: item.Link ?? "#",
          })),
        },
      )}
    />
  ),
  [SupportAppearance.Home15.key]: (props) => {
    const items = getListItems(props);
    console.log("items : ", items);

    return (
      <HomeFifteenSupportSectionGenerated
        {...buildGeneratedSectionProps<HomeFifteenSupportSectionGeneratedProps>(
          "HomeFifteenSupportSection",
          {
            divDiv0Div0DivText: props.setting.Title ?? undefined,
            divDiv0Div0DivText2: props.setting.Subtitle ?? undefined,
            divDiv0Div0P0PText:
              getItemText(items[0]) ?? props.setting.Description ?? undefined,
            divDiv0Div0P1PText: getItemText(items[1]) ?? undefined,
            divDiv0Div0P2PText: getItemText(items[2]) ?? undefined,
            divDiv0Div0P3PText: getItemText(items[3]) ?? undefined,
            divImageWithBasePath0ImageSrc:
              getSectionImageUrl(props) ?? undefined,
            divImageWithBasePath0ImageAlt: getSectionImageAlt(props, "support"),
          },
        )}
      />
    );
  },
};

const GeneratedSupportSection: FC<SupportSectionProps> = (props) => {
  return renderGeneratedSection(
    props,
    generatedSupportRenderers,
    SupportAppearance.Home8.key,
    (sectionProps) => sectionProps.setting.Appearance?.Key,
  );
};

export default GeneratedSupportSection;
